/* eslint-disable no-restricted-globals */
/* eslint-disable no-unused-expressions */
import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

import { API_TOKEN, API_URL, FNAD_PRODUCION_API } from "../../Config/secrets";

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: null,
  totalWholesaler: 0,
  allWholesaler: {},
  selectedFilters: {
    page: 1,
    filters: {},
  },
  filters: {},
  addWholeSaler: null,
  updateWholeSaler: null,
};

const slice = createSlice({
  name: "wholesaler",
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },
    resetWholeSaler: () => initialState,
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    setSelectedFilters(state, action) {
      state.selectedFilters = action.payload;
    },
    getAllWholeSalerSuccess(state, action) {
      state.error = null;
      state.totalWholesaler = action.payload.total;
      state.allWholesaler = {
        ...state.allWholesaler,
        [action.payload.page]: action.payload.data,
      };
      state.isLoading = false;
    },
    getAddWholeSalerSuccess(state, action) {
      state.isLoading = false;
      state.error = null;
      state.addWholeSaler = action.payload;
    },
    getUpdateWholeSalerSuccess(state, action) {
      state.isLoading = false;
      state.error = null;
      state.updateWholeSaler = action.payload;
    },
    getFiltersSuccess(state, action) {
      state.isLoading = false;
      state.error = null;
      state.filters = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const {
  getAddWholeSalerSuccess,
  getAllWholeSalerSuccess,
  getUpdateWholeSalerSuccess,
  resetWholeSaler,
  setSelectedFilters,
} = slice.actions;

// ----------------------------------------------------------------------

const header = {
  Authorization: API_TOKEN,
};
export function assignWholesalerToCompany(data) {
  return async (dispatch) => {
    try {
      const response = await axios.put(`${API_URL}/wholesaler/assign`, data, {
        headers: header,
      });

      if (response.data?.statusCode === 200) {
        toast.success("Wholesaler Company Updated");
      } else {
        toast.error(response?.data?.message || "Something went wrong");
      }

      return response?.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error?.response?.data));
      return error?.response?.data;
    }
  };
}

export function UnassignWholesalerToCompany(data) {
  return async (dispatch) => {
    try {
      const response = await axios.put(`${API_URL}/wholesaler/unassign`, data, {
        headers: header,
      });

      if (response.data?.statusCode === 200) {
        toast.success("Wholesaler Un-assigned to company");
      } else {
        toast.error(response?.data?.message || "Something went wrong");
      }

      return response?.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error?.response?.data));
      return error?.response?.data;
    }
  };
}

export function addWholeSalerFunc(data) {
  return async (dispatch) => {
    try {
      const response = await axios.post(`${API_URL}/company/upload-data-manually`, data, {
        headers: header,
      });

      if (response?.data.statusCode === 200) {
        toast.success("Wholesaler Created", { autoClose: 3000 });
      }
      return response?.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error?.response?.data));
      toast.error(error?.response?.data?.message || "Error creating wholesaler", { autoClose: 3000 });
      return error?.response?.data;
    }
  };
}

export function getFilters() {
  return async (dispatch) => {
    try {
      const response = await axios.get(`${API_URL}/wholesaler/data-to-filter-overall`, {
        headers: header,
      });

      if (response?.statusCode === 400 && !response?.data) {
        toast.error(response?.message || "Something went wrong", { autoClose: 3000 });
        return;
      }

      if (response?.data?.statusCode === 200) {
        dispatch(slice.actions.getFiltersSuccess(response?.data?.data));
      }
      return response;
    } catch (error) {
      toast.error(error?.message || "Something went wrong", { autoClose: 3000 });
      dispatch(slice.actions.hasError(error?.response));
      return error?.response;
    }
  };
}

export function addWholeSalerFuncViaFile(data) {
  return async (dispatch) => {
    try {
      const response = await axios.post(`${FNAD_PRODUCION_API}/wholesaler/create_wholesaler_with_file`, data, {
        headers: header,
      });

      dispatch(slice.actions.getAddWholeSalerSuccess(response.data));
      return response?.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error?.response?.data));
      toast.error(error?.response?.data?.message || "Error uploading file", { autoClose: 3000 });
      return error?.response?.data;
    }
  };
}

export function updateWholeSalerData({ data, cb }) {
  return async (dispatch) => {
    try {
      const response = await axios.put(`${API_URL}/wholesaler/update`, data, {
        headers: header,
      });
      console.log(data, response)

      if (response?.data.statusCode === 200) {
        if (typeof cb === 'function') {
          cb()
        }
        toast.success("Wholesaler Updated", { autoClose: 3000 });
      }
      if (response.data.statusCode >= 400) {
        toast.error(response?.data?.message);
      }
      dispatch(slice.actions.getUpdateWholeSalerSuccess(response.data));
      return response?.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error?.response?.data));
      console.log('er', error)
      toast.error(error?.response?.data?.message || "Error updating wholesaler", { autoClose: 3000 });
      return error?.response?.data;
    }
  };
}

export function getAllWholeSalers(page = 1, filters, query, take = 10) {
  return async (dispatch) => {
    try {
      let payload = { skip: page, take };
      const isFilters = Object.keys(filters || {}).length > 0;

      if (isFilters) {
        payload.filters = true;
        payload = { ...payload, ...filters };
      }
      if (query) payload.query = query;

      const response = await axios.post(`${API_URL}/wholesaler/get-overall`, payload, {
        headers: header,
      });

      console.log('GET WHOLESALERS', response.data)
      if (response?.data?.statusCode === 200) {
        dispatch(
          slice.actions.getAllWholeSalerSuccess({
            page,
            total: response?.data?.data?.count,
            data: response?.data?.data?.data,
          })
        );
        return response?.data?.data?.data;
      }
    } catch (error) {
      toast.error(error?.message || "Failed to fetch wholesalers", { autoClose: 3000 });
      dispatch(slice.actions.hasError(error?.response?.data));
      return error?.response?.data;
    }
  };
}

export function getFilteredWholesaler(page = 1, query, filter, limit = 10) {
  return async (dispatch) => {
    try {
      const response = await axios.get(
        `${FNAD_PRODUCION_API}/wholesaler/get_filtered_wholesalers?page=${page}&limit=${limit}&filter=${filter || "New to old"}&search=${query || ""}`,
        {
          headers: header,
        }
      );

      if (response?.data?.status === 200) {
        dispatch(
          slice.actions.getAllWholeSalerSuccess({
            page,
            total: response?.data?.data?.total,
            data: response?.data?.data?.wholesalers,
          })
        );
        return response?.data?.data?.brands;
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error?.response?.data));
      toast.error(error?.response?.data?.message || "Error fetching filtered data", { autoClose: 3000 });
      return error?.response?.data;
    }
  };
}
